import React from 'react';
import { Button, Typography } from '@/components/common';
import { InputRadio } from '@/components/form';
import { useForm } from 'react-hook-form';
import useModal from '@/hooks/useModal';
import { ModalHeader } from '@/components/dashboard';

interface Props {
	isOpen: boolean;
	isCasePublished: boolean;
	isCaseOpenToClients: boolean;
	handleContinue: (status: boolean) => void;
	setIsOpen: (value: boolean) => void;
}

export const IntakeStatus: React.FC<Props> = ({
	isOpen,
	setIsOpen,
	isCasePublished,
	handleContinue,
}) => {
	const {
		Modal: ModalCaseStatus,
		show: showCaseStatus,
		hide: hideCaseStatus,
	} = useModal();
	const { register, watch } = useForm();

	const status = watch('status');

	React.useEffect(() => {
		if (isOpen) {
			showCaseStatus();
		}
	}, []);

	const handleClose = () => {
		hideCaseStatus();
		setIsOpen(false);
	};

	return (
		<ModalCaseStatus
			backgroundColor="white"
			title={<ModalHeader title="Intake Status" />}
			classNameCardContainer={'!w-[532px]'}
			classNameContainerChildren="space-y-8"
			onClose={handleClose}
		>
			<Typography type="regular-16" className="text-black text-center">
				Do you want to continue accepting new clients <br /> for this case?
			</Typography>
			<Typography type="semibold-16" className="text-black text-center">
				This action cannot be undone.
			</Typography>

			<div className="border border-[#0D061614] rounded-2xl bg-gray-20 p-4 space-y-[10px] text-left">
				<InputRadio
					name="status"
					value={'close'}
					register={register}
					className="text-sm items-center"
					disabled={!isCasePublished}
				>
					Close to new clients
				</InputRadio>
				<InputRadio
					name="status"
					value={'open'}
					register={register}
					className="text-sm items-center"
					disabled={!isCasePublished}
				>
					Open to new clients
				</InputRadio>
			</div>
			<div className="flex items-center gap-2 justify-center">
				<Button
					type="button"
					decoration="secondary"
					size="fit"
					onClick={handleClose}
				>
					Close
				</Button>
				<Button
					type="button"
					decoration="primary"
					size="fit"
					disabled={!status}
					onClick={() => handleContinue(status === 'open')}
				>
					Confirm
				</Button>
			</div>
		</ModalCaseStatus>
	);
};
